export var SpinnerOverlayStatusEnum;
(function (SpinnerOverlayStatusEnum) {
    SpinnerOverlayStatusEnum["CLOSED"] = "closed";
    SpinnerOverlayStatusEnum["CLOSING"] = "closing";
    SpinnerOverlayStatusEnum["OPENED"] = "opened";
    SpinnerOverlayStatusEnum["OPENING"] = "opening";
})(SpinnerOverlayStatusEnum || (SpinnerOverlayStatusEnum = {}));
//# sourceMappingURL=spinner-overlay-status.js.map
